
import { RutaLocal } from '../componentes/funcionesEspeciales'
import Logo from '../media/img/logo_principal.png'
function PoliticasPrivacidad() {

    return (<>
        <div className='container py-3' style={{ textAlign: "justify" }}>

            <h2>INFORMACIÓN SOBRE POLÍTICAS Y PRIVACIDAD</h2>
            <p>
                En EL GALPON POLLOS Y PARRILLAS, valoramos su privacidad y nos comprometemos a proteger sus datos personales. Esta Política de Privacidad explica cómo recopilamos, usamos, divulgamos y protegemos su información cuando utiliza nuestro sitio web y nuestros servicios.
            </p>
            <h5>
                1. Información que Recopilamos
            </h5>
            <p>
                Información Personal: Podemos recopilar información personal que usted nos proporciona directamente al registrarse, realizar un pedido o comunicarse con nosotros. Esto puede incluir su nombre, dirección, número de teléfono, dirección de correo electrónico y detalles de pago.

                Información de Cookies: Utilizamos cookies y tecnologías similares para recopilar información sobre su actividad en nuestro sitio web. Las cookies nos ayudan a mejorar nuestros servicios y su experiencia de usuario.
            </p>
            <h5>
                2. Uso de la Información
            </h5>

            2.1. Utilizamos la información recopilada para los siguientes fines:<br />

            <p>
                Procesar y gestionar sus pedidos.
                Mejorar nuestros productos y servicios.
                Comunicarnos con usted sobre su cuenta, pedidos y cualquier consulta que pueda tener.
                Enviar promociones, ofertas y actualizaciones sobre nuestros productos (si ha optado por recibir estas comunicaciones).
                Personalizar su experiencia en nuestro sitio web.
                Cumplir con nuestras obligaciones legales y reglamentarias.
            </p>
            <h5>
                3. Divulgación de la Información
            </h5>

            3.1. No vendemos, alquilamos ni intercambiamos su información personal con terceros. Podemos compartir su información en las siguientes circunstancias:
            <p>
                Proveedores de Servicios: Con terceros que nos ayudan a proporcionar nuestros servicios, como procesadores de pagos y empresas de entrega.
                Obligaciones Legales: Cuando sea necesario para cumplir con una ley, regulación o proceso legal aplicable, o para responder a una solicitud gubernamental.
                Protección de Derechos: Para proteger los derechos, propiedad o seguridad de EL GALPON POLLOS Y PARRILLAS, nuestros usuarios u otros.
            </p>
            <h5>
                4. Seguridad de la Información
            </h5>
            <p>
                4.1. Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal contra el acceso no autorizado, la divulgación, el uso indebido o la alteración. Sin embargo, no podemos garantizar la seguridad absoluta de la información transmitida a través de Internet.
            </p>
            <h5>
                5. Retención de Datos
            </h5>
            <p>
                5.1. Retenemos su información personal solo durante el tiempo necesario para cumplir con los fines para los cuales fue recopilada, a menos que se requiera un período de retención más largo o permitido por la ley.
            </p>
            <h5>
                6. Derechos del Usuario
            </h5>
            <p>
                6.1. Usted tiene el derecho de:<br />
                Acceder a su información personal que tenemos.
                Solicitar la corrección o eliminación de su información personal.
                Oponerse al procesamiento de su información personal.
                Solicitar la restricción del procesamiento de su información personal.
                Solicitar la portabilidad de su información personal.
                6.2. Para ejercer estos derechos, puede contactarnos a través de [email de contacto].

            </p>
            <h5>
                7. Cambios en esta Política de Privacidad
            </h5>
            <p>

                7.1. Podemos actualizar esta Política de Privacidad de vez en cuando para reflejar cambios en nuestras prácticas o en la legislación aplicable. Las actualizaciones se publicarán en nuestro sitio web y entrarán en vigor a partir de su publicación.
            </p>

            <h5>
                8. Contacto
            </h5>
            <p>

                Si tiene alguna pregunta o inquietud sobre esta Política de Privacidad, puede contactarnos al: 959375800
            </p>
            <h5>
                9. Consentimiento
            </h5>
            <p>
                Al utilizar nuestro sitio web y nuestros servicios, usted consiente la recopilación, uso y divulgación de su información personal según se describe en esta Política de Privacidad.
                Gracias por confiar en EL GALPON POLLOS Y PARRILLAS. Nos comprometemos a proteger su privacidad y a ofrecerle un servicio de calidad.
            </p>

        </div>
    </>)
}
export default PoliticasPrivacidad;